interface IProps {
  text: string;
}

export const EmptyDrop = ({ text }: IProps) => (
  <div className={'d-flex h-50 w-100 align-items-center justify-content-center'}>{text}</div>
);
